export const TABS_CLASS_NAME = 'kurama-tabs'
export const TABS_FLEX_CONTAINER_CLASS_NAME = 'kurama-tabs-flex-container'
